export const Method = {
  1: "Online",
  2: "Onsite",
};
export const Framework = {
  PDCA: 1,
  PD: 2,
};

export const SessionType = {
  GROW: 1,
  Behaviour: 2,
  Conversational: 3,
};

export const TableConfig = {
  resultPerPage: 10,
  pageRangeDisplayed: 5,
};

export const SessionStatus = {
  PENDING_CONFIRMATION: 0,
  SCHEDULED: 1,
  PENDING_CHECKPOINTS: 2,
  PROGRESSING: 3,
  READY_FOR_REVIEW: 4,
  PENDING_RATING: 5,
  ARCHIVED: 6,
  INCOMPLETE: 7,
};

export const DeleteSessionStatus = [
  SessionStatus.PENDING_CONFIRMATION,
  SessionStatus.SCHEDULED,
  SessionStatus.PENDING_CHECKPOINTS,
  SessionStatus.PROGRESSING,
  SessionStatus.READY_FOR_REVIEW,
  SessionStatus.INCOMPLETE,
];

export const PDCAStages = {
  PLAN: 1,
  DO: 2,
  CHECK: 3,
  ACT: 4,
};

export const COACH_URL = [
  "/sessions/details/",
  "/sessions/grow/details/",
  "/sessions/set-checkpoints/",
  "/sessions/update-checkpoints/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
];

export const CONV_COACH_URL = [
  "/sessions/details/",
  "/sessions/details/",
  "/sessions/set-checkpoints/",
  "/sessions/update-checkpoints/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
];

export const PD_COACH_URL = [
  "/sessions/details/",
  "/sessions/grow/details/",
  "/sessions/set-checkpoints/",
  "/sessions/set-checkpoints/",
  "/sessions/set-checkpoints/",
  "/sessions/set-checkpoints/",
];

export const COACHEE_URL = [
  "/sessions/details/",
  "/sessions/grow/details/",
  "/sessions/coaching/summary/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
  "/sessions/archive-session/",
  "/sessions/archive-session/",
];

export const CONV_COACHEE_URL = [
  "/sessions/details/",
  "/sessions/details/",
  "/sessions/coaching/summary/",
  "/sessions/review-summary/",
  "/sessions/review-summary/",
  "/sessions/archive-session/",
  "/sessions/archive-session/",
];

export const PD_COACHEE_URL = [
  "/sessions/details/",
  "/sessions/grow/details/",
  "/sessions/coaching/summary/",
  "/sessions/coaching/summary/",
  "/sessions/coaching/summary/",
  "/sessions/coaching/summary/",
];

export const StatusMapping = {
  0: "Pending confirmation",
  1: "Scheduled",
  2: "Pending checkpoints",
  3: "Progressing",
  4: "Ready for review",
  5: "Pending rating",
  6: "Completed",
};
// Status Mapping
// 0-Pending Confirmation
// 1-Scheduled,
// 2-Pending Checkpoints,
// 3-Progressing,
// 4-Ready for Review,
// 5-Pending Rating,
// 6-Completed

export const Config = {
  scorecardClientID: "752d55e83bd2882f55d8a9142750f6d6",
};

export const LanguageConfig = {
  Malaysia: "en",
  Thailand: "th",
  China: "zh",
  "Hong Kong": "hk",
  Korea: "kr",
};
export const LanguageLabelConfig = {
  Malaysia: "English",
  Thailand: "ไทย",
  China: "中文(简体)",
  "Hong Kong": "中文(繁體)",
  Korea: "한국어",
};

